// extracted by mini-css-extract-plugin
export default {"container":"eLjWsWc5","overlay":"a6XdIZqA","overlayTop":"TSQgEOyy","overlayContentTop":"jkvMNx9k","overlayContent":"oHXnVPYk","slider":"KZNwNpmU"};